<nav *ngIf="!hideMenu" id="tabbar" class="mb-1">
    <ul class="nav flex-row gap-3 text-center">
        <li class="nav-item flex-fill" routerLinkActive="active">
            <a class="nav-link" routerLink="promoter/venues"><span class="spam-text">{{ 'VENUES.VENUES_PANEL' | translate }}</span></a>
        </li>
        <li class="nav-item flex-fill" routerLinkActive="active">
            <a class="nav-link" routerLink="promoter/events"><span class="spam-text">{{ 'EVENTS.EVENTS_PANEL' | translate }}</span></a>
        </li>
    </ul>
</nav>
